import { setTerms } from './helpers';

export const setBuildingHouseLine = setTerms('building_house_line_type__shopping_area');
